export default "__VITE_ASSET__b9930aeb__"